<!-- Toast notifications -->
<p-toast key="clinic-details"></p-toast>

<!-- Modern Header Section -->
<div class="m-4">
  <div class="clinic-details-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="clinic-details-title">
          <i class="pi pi-building mr-3"></i>
          Clinic Details
        </h1>
        <p class="clinic-details-subtitle">
          View clinic information and contact details
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Main Content Area -->
<div class="m-4 clinic-details-content">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-content">
      <p-progressSpinner
        strokeWidth="3"
        animationDuration=".5s"
        styleClass="loading-spinner"
      ></p-progressSpinner>
      <p class="loading-text">Loading clinic details...</p>
    </div>
  </div>

  <!-- Main Content -->
  <div *ngIf="!loading" class="clinic-container">
    <div class="modern-details">
      
      <!-- Basic Information Section -->
      <div class="content-section">
        <div class="section-header">
          <div class="header-info">
            <h2 class="section-title">
              <i class="pi pi-info-circle mr-2"></i>
              Basic Information
            </h2>
            <p class="section-description">
              Primary clinic details and contact information
            </p>
          </div>
        </div>

        <div class="details-grid">
          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-building mr-1"></i>
              Clinic Name
            </div>
            <div class="detail-value">{{ data?.name || 'N/A' }}</div>
          </div>

          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-user mr-1"></i>
              Professional Nurse
            </div>
            <div class="detail-value">{{ data?.professional_nurse || 'N/A' }}</div>
          </div>

          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-phone mr-1"></i>
              Contact Number
            </div>
            <div class="detail-value">{{ data?.users[0].nurse_details?.contact_number }}</div>
          </div>

          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-envelope mr-1"></i>
              Email Address
            </div>
            <div class="detail-value">{{ data?.email || 'N/A' }}</div>
          </div>
        </div>
      </div>

      <!-- Address Information Section -->
      <div class="content-section">
        <div class="section-header">
          <div class="header-info">
            <h2 class="section-title">
              <i class="pi pi-map-marker mr-2"></i>
              Address Information
            </h2>
            <p class="section-description">
              Complete address and location details
            </p>
          </div>
        </div>

        <div class="details-grid">
          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-home mr-1"></i>
              Address Line 1
            </div>
            <div class="detail-value">{{ data?.address_line_1 || 'N/A' }}</div>
          </div>

          <div class="detail-field" *ngIf="data?.address_line_2">
            <div class="detail-label">
              <i class="pi pi-home mr-1"></i>
              Address Line 2
            </div>
            <div class="detail-value">{{ data?.address_line_2 }}</div>
          </div>

          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-map mr-1"></i>
              Street Address
            </div>
            <div class="detail-value">{{ data?.street_address || 'N/A' }}</div>
          </div>

          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-map-pin mr-1"></i>
              Suburb
            </div>
            <div class="detail-value">{{ data?.suburb || 'N/A' }}</div>
          </div>

          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-building mr-1"></i>
              City
            </div>
            <div class="detail-value">{{ data?.city || 'N/A' }}</div>
          </div>

          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-globe mr-1"></i>
              District
            </div>
            <div class="detail-value">{{ data?.district || 'N/A' }}</div>
          </div>

          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-globe mr-1"></i>
              Province
            </div>
            <div class="detail-value">{{ data?.province || 'N/A' }}</div>
          </div>

          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-mail mr-1"></i>
              Postal Code
            </div>
            <div class="detail-value">{{ data?.postal_code || 'N/A' }}</div>
          </div>
        </div>
      </div>

      <!-- Professional Information Section -->
      <div class="content-section">
        <div class="section-header">
          <div class="header-info">
            <h2 class="section-title">
              <i class="pi pi-certificate mr-2"></i>
              Professional Information
            </h2>
            <p class="section-description">
              Nursing credentials and professional details
            </p>
          </div>
        </div>

        <div class="details-grid">
          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-id-card mr-1"></i>
              SANC Number
            </div>
            <div class="detail-value">{{ data?.sanc_number || 'N/A' }}</div>
          </div>

          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-briefcase mr-1"></i>
              Practice Number
            </div>
            <div class="detail-value">{{ data?.practice_number || 'N/A' }}</div>
          </div>

          <div class="detail-field">
            <div class="detail-label">
              <i class="pi pi-graduation-cap mr-1"></i>
              SANC Qualification
            </div>
            <div class="detail-value">{{ data?.sanc_qualification || 'N/A' }}</div>
          </div>
        </div>
      </div>

      <!-- Additional Information Section -->
      <div class="content-section" *ngIf="data?.id || data?.user_id || data?.date_created || data?.date_updated">
        <div class="section-header">
          <div class="header-info">
            <h2 class="section-title">
              <i class="pi pi-database mr-2"></i>
              Additional Information
            </h2>
            <p class="section-description">
              System information and metadata
            </p>
          </div>
        </div>

        <div class="details-grid">
          <div class="detail-field" *ngIf="data?.id">
            <div class="detail-label">
              <i class="pi pi-hashtag mr-1"></i>
              Clinic ID
            </div>
            <div class="detail-value">{{ data?.id }}</div>
          </div>

          <div class="detail-field" *ngIf="data?.user_id">
            <div class="detail-label">
              <i class="pi pi-user mr-1"></i>
              User ID
            </div>
            <div class="detail-value">{{ data?.user_id }}</div>
          </div>

          <div class="detail-field" *ngIf="data?.date_created">
            <div class="detail-label">
              <i class="pi pi-calendar mr-1"></i>
              Date Created
            </div>
            <div class="detail-value">{{ data?.date_created | date:'medium' }}</div>
          </div>

          <div class="detail-field" *ngIf="data?.date_updated">
            <div class="detail-label">
              <i class="pi pi-calendar-plus mr-1"></i>
              Last Updated
            </div>
            <div class="detail-value">{{ data?.date_updated | date:'medium' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
